import { useEffect, useState, useCallback } from "react";
import { api, API } from "@/lib/api";

// Public client-branding config (which logo slots are set + version for cache-busting).
// Shared across sidebar + login. Fetched once and refreshable after admin edits.
let cached = null;

export function logoUrl(slot, version) {
  return `${API}/branding/logo/${slot}?v=${version || 0}`;
}

export function useBranding() {
  const [branding, setBranding] = useState(cached);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/branding");
      cached = r.data;
      setBranding(r.data);
    } catch {
      /* branding is optional — ignore failures */
    }
  }, []);

  useEffect(() => { if (cached) setBranding(cached); else load(); }, [load]);

  return { branding: branding || { client: false, partner: false, version: 0 }, refresh: load };
}
